
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venda-direta/governo",
      function () {
        return require("private-next-pages/venda-direta/governo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venda-direta/governo"])
      });
    }
  